import React from 'react';
import {ISelectProps, SelectInput} from '~/components/Controls/Select';
import {FormField, hasError, IFieldProps, onChangeField} from '~/components/Form';
import {Intent} from '~/lib/intent';
import {useResource} from '~/lib/loader';
import {fetchBidderFloorTypes} from '~/modules/Bidders/api';

type ISelectFloorTypeProps = Omit<ISelectProps<string>, 'items'>;

export const SelectFloorType = ({
    disabled,
    ...props
}: ISelectFloorTypeProps) => {
    const {resource, isPending} = useResource(() => fetchBidderFloorTypes(), []);
    return <SelectInput {...props} disabled={disabled || isPending}
        rightIcon={isPending && <i className='fa fa-spinner fa-spin'/>}
        items={resource.map(floorType => ({
            label: floorType,
            value: floorType
        }))}/>;
};

export const SelectFloorTypeField = (props: IFieldProps<ISelectFloorTypeProps>) => <FormField {...props}>
    <SelectFloorType {...props.options}
        intent={hasError(props) && Intent.DANGER}
        value={props.field.value} onChange={value => onChangeField(props, value)}
    />
</FormField>;
